import { Button, Card, Popconfirm, Space, Typography, notification } from 'antd';
import React from 'react';
import { CompanyModel } from '../../../types/admin';
import { disconnectShopify } from '../../../api/disconnectShopify';

interface CompanyShopifyTabProps {
    company: CompanyModel;
    canManage: boolean;
    shopify: {
        shopUrl?: string;
        status?: string;
    };
    onOpenShopifyModal: () => void;
}

const CompanyShopifyTab: React.FC<CompanyShopifyTabProps> = ({
    company,
    canManage,
    shopify,
    onOpenShopifyModal,
}) => {
    const handleDisconnect = async () => {
        try {
            await disconnectShopify(company.id);
            notification.success({ message: 'Shopify disconnected' });
        } catch (error: any) {
            notification.error({
                message: 'Failed to disconnect',
                description: error?.message || String(error),
            });
        }
    };

    return (
        <Card
            title="Connect Shopify Shop"
            extra={
                <Space>
                    {company.modules?.shopify ? (
                        <Popconfirm
                            title="Replace Shopify shop?"
                            description="This will overwrite the existing Shopify connection for this company."
                            onConfirm={onOpenShopifyModal}
                            okText="Replace"
                            cancelText="Cancel"
                        >
                            <Button type="primary" disabled={!canManage}>
                                Replace Shop
                            </Button>
                        </Popconfirm>
                    ) : (
                        <Button
                            type="primary"
                            disabled={!canManage}
                            onClick={onOpenShopifyModal}
                        >
                            Add Shop
                        </Button>
                    )}
                    <Popconfirm
                        title="Disconnect Shopify?"
                        description="This will remove the Shopify connection and delete synced Shopify data for this company."
                        onConfirm={handleDisconnect}
                        okText="Disconnect"
                        cancelText="Cancel"
                    >
                        <Button
                            danger
                            disabled={!canManage || !company.modules?.shopify}
                        >
                            Disconnect
                        </Button>
                    </Popconfirm>
                </Space>
            }
        >
            {company.modules?.shopify ? (
                <Space direction="vertical">
                    <div>Shop URL: {shopify.shopUrl || '-'}</div>
                    <div>Status: {shopify.status || '-'}</div>
                </Space>
            ) : (
                <Typography.Text type="secondary">
                    No Shopify shop connected.
                </Typography.Text>
            )}
        </Card>
    );
};

export default CompanyShopifyTab;
